import {getDeclension} from "../../utils/common";
import {confirmModal} from "../index";
import {NotificationConfirm} from "../notification-confirm";

class NotificationRemoveButton {
  private element: HTMLElement;
  private confirmModal: NotificationConfirm;

  constructor(element: HTMLElement) {
    this.element = element;

    this.onElementClick = this.onElementClick.bind(this);

    this.element.addEventListener(`click`, this.onElementClick);
  }

  showButton() {
    this.confirmModal = confirmModal;
    this.element.classList.remove(`notifications__remove-all--hide`);
  }

  hideButton() {
    this.element.classList.add(`notifications__remove-all--hide`);
  }

  setCount(count) {
    this.element.textContent = `Удалить ${count} ${getDeclension(count,
      [`уведомление`, `уведомления`, `уведомлений`])}`;
  }

  onElementClick() {
    this.confirmModal.showElement();
  }
}

export {NotificationRemoveButton};
